import "./Rewards.scss";

import gmBronze from "../assets/gmBronze.png";
import gmSilver from "../assets/gmSilver.png";
import gmGold from "../assets/gmGold.png";

const Partnerships: React.FC = () => {
  return (
    <>
      <div className="section">
        <div className="container">
          <div className="card">
            <div className="card-content">
              <div className="columns is-vcentered">
                <div className="column is-8">
                  <div className="" id="rewardTitle">
                    Rewarding <br /> Engagement
                  </div>
                  <div id="bodyText">
                    <p>
                      Introducing the Reply Guys Rewards! We're excited to give
                      back to our dedicated community members by offering GMs as
                      a token of our appreciation. To make it even more
                      exciting, we'll be hosting a variety of competitions
                      throughout the week, giving you plenty of opportunities to
                      earn GMs.
                    </p>
                    <br />
                    <p>
                      But what exactly are GMs? GMs are a crucial part of the
                      Reply Guys ecosystem, serving as your key to unlocking a
                      wide range of exciting rewards both before and after
                      minting. With GMs, you can gain access to exclusive
                      events, special offers, and much more!
                    </p>
                    <br />
                    <p>
                      So don't miss out on the fun! Stay active on our Discord
                      channel and take advantage of the numerous chances to
                      claim your GMs. Remember, the more you participate, the
                      more rewards you can unlock. Happy claiming, and see you
                      on Discord!
                    </p>
                  </div>
                </div>
                <div className="column is-4">
                  <div className="column">
                    <div className="gm-image-container">
                      <img
                        className="gm-poap gm-gold"
                        src={gmGold}
                        alt="gm-gold"
                      />
                      <div className="gm-middle-row">
                        <img
                          className="gm-poap gm-silver"
                          src={gmSilver}
                          alt="gm-silver"
                        />
                        <img
                          className="gm-poap gm-bronze"
                          src={gmBronze}
                          alt="gm-bronze"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Partnerships;
